import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYoutubeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 35,
	viewBox: "0 0 35 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 17.5,
		cy: 17.5,
		r: 17,
		stroke: "#003B6F"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.6418 19.8937V14.704L20.5033 17.3143L15.6418 19.8937ZM17.5 11C13.7132 11 11.2021 11.1857 11.2021 11.1857C10.8505 11.227 10.0771 11.227 9.39406 11.9698C9.39406 11.9698 8.84161 12.527 8.68089 13.8063C8.49005 15.3024 8.50009 16.7984 8.50009 16.7984V18.2016C8.50009 18.2016 8.49005 19.6976 8.68089 21.1937C8.84161 22.4627 9.39406 23.0302 9.39406 23.0302C10.0771 23.7627 10.9811 23.7421 11.3829 23.8143C11.3829 23.8143 12.8192 23.9587 17.5 24C21.2868 24 23.7979 23.804 23.7979 23.804C24.1495 23.7627 24.9229 23.7627 25.6059 23.0302C25.6059 23.0302 26.1584 22.4627 26.3191 21.1937C26.51 19.6976 26.4999 18.2016 26.4999 18.2016V16.7984C26.4999 16.7984 26.51 15.3024 26.3191 13.8063C26.1584 12.527 25.6059 11.9698 25.6059 11.9698C24.9229 11.227 24.1495 11.227 23.7979 11.1857C23.7979 11.1857 21.2868 11 17.5 11Z",
		fill: "#003B6F"
	})]
});
export default SvgYoutubeIcon;
